
import {
  ViewPOObraMigoAprovado,
  LoteIntegracaoMigo
} from '../index';


export class ObraMigoAprovado {
  "id";
  "numeroDaObra";
  "numeroDaPO";
  "itemDePO";
  "MIGOPodeSerLiberado";
  "areaEricsson";
  "dataCadastro";
  "pendencia";
  "lote";
  "linkDaObra";
  POs;
  LoteIntegracao;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ObraMigoAprovado`.
   */
  static getModelName() {
    return "ObraMigoAprovado";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ObraMigoAprovado for dynamic purposes.
  **/
  static factory(data) {
    return new ObraMigoAprovado(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ObraMigoAprovado',
      plural: 'ObraMigoAprovados',
      path: 'ObraMigoAprovados',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "numeroDaObra": {
          name: 'numeroDaObra',
          type: 'string'
        },
        "numeroDaPO": {
          name: 'numeroDaPO',
          type: 'string'
        },
        "itemDePO": {
          name: 'itemDePO',
          type: 'number'
        },
        "MIGOPodeSerLiberado": {
          name: 'MIGOPodeSerLiberado',
          type: 'string'
        },
        "areaEricsson": {
          name: 'areaEricsson',
          type: 'boolean'
        },
        "dataCadastro": {
          name: 'dataCadastro',
          type: 'Date'
        },
        "pendencia": {
          name: 'pendencia',
          type: 'string'
        },
        "lote": {
          name: 'lote',
          type: 'number'
        },
        "linkDaObra": {
          name: 'linkDaObra',
          type: 'string'
        },
      },
      relations: {
        POs: {
          name: 'POs',
          type: 'ViewPOObraMigoAprovado[]',
          model: 'ViewPOObraMigoAprovado'
        },
        LoteIntegracao: {
          name: 'LoteIntegracao',
          type: 'LoteIntegracaoMigo',
          model: 'LoteIntegracaoMigo'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ObraMigoAprovado.js